module.exports = __webpack_public_path__ + "static/img/UW_logo_pl.9d46ef0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/UW_logo_pl.svg
// module id = ISj2
// module chunks = 1